import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrd84yrt7y: FaireProductEntity = {
  token: "p_vrd84yrt7y",
  type: "product",
  name: "Women's Soft Plush Double Zip Jacket | 40% Off",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/33460614308ba8ce824ef9943242da8b9b5de64f1222ca43e4c4d38344e8a05f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9206ac2a0c1b12bf2aed7898e697526b08d948658d6e7f0e0fc35462b09b24a6.png",
    "https://cdn.faire.com/fastly/e19ee2ad2296c04180deeb35614999133d869cda5bb02a42487df6b36f544949.jpeg",
    "https://cdn.faire.com/fastly/a16c18851c2deae708b4e50311a5be4387d2c68aa3f0de6edb5317dc3be8e589.jpeg",
    "https://cdn.faire.com/fastly/7aaeb0f88bb6fb5c2f2d44966b240e3768eeb207a561fbe1fa1350869db97042.jpeg",
    "https://cdn.faire.com/fastly/766ee050513380a6c934005299c610d6333a82ceb43970e3314727492083fae1.jpeg",
    "https://cdn.faire.com/fastly/1e7601ca91b3fd6b8824ec321b4ce0ba1d6c258e65b50d5349aa6ee3b8f98f12.jpeg",
    "https://cdn.faire.com/fastly/f6d92e514c18421ee5dc664fe1ce36fa31560add8ec2171af959082702ebecc2.jpeg",
    "https://cdn.faire.com/fastly/29a695f098d8999cdd56bfb35d9bb065805f3e93ade2cd5d3c6ef2e761fda33e.jpeg",
    "https://cdn.faire.com/fastly/71a75c4e72a6fc1490b47a1689dfe1f3327bd35a107e9a09ce297030d83ef799.jpeg",
    "https://cdn.faire.com/fastly/617eb1e12bde3fc7f58f9ecd5b82433db0808bc0e6b9ad4dd6b83022ef39adcb.jpeg",
    "https://cdn.faire.com/fastly/6f42bb68d0c503c9501516008c86688ee7750b1cfbab87e3a062716adf149f1a.jpeg",
    "https://cdn.faire.com/fastly/6e55d498b19f0c8291a7d440d82203ec9a85bd5ddce68dfa803668b3d0acb1c1.jpeg",
    "https://cdn.faire.com/fastly/5d2e90906b02a7253f61068bc8fdf70ad1ff4090f086759a0e96af31876ca1e1.jpeg"
  ],
  priceDollars: 35,
  description: "Now $35 (regularly $59—40% off).\n\nCozy, lightened for spring. Made from our DreamPlush fabric, this Favorite Things jacket surrounds you in cloud-like softness with a luxe, velvety finish—without feeling heavy. Designed with a relaxed silhouette, adjustable waist cinch, and full-zip front, it layers effortlessly over your everyday looks. Perfect for breezy mornings, over-air-conditioned afternoons, and on-the-go moments, it’s your go-to for staying comfortably polished all season long.\n\nFeatures:\n•\tFull front double zip for easy layering and styling\n•\tDrawcord waist for customizable fit and flattering shape\n•\tRelaxed fit with enough structure to wear indoors or out\n\nMaterials & Care:\n•\tFabric: Made from ultra-soft, velvety DreamPlush fabric for a cozy, elevated feel\n•\tFabric Content: 100% Polyester\n•\tMachine Washable\n•\tFor best results: Fully zip and turn inside out, wash cold, and line dry.  Or dry clean.\n\n\n",
  tags: [],
  msrpDollars: 134,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:01.679Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
